import { Component, effect, inject, input, OnInit, output, signal } from '@angular/core';
import { FormArray } from '@angular/forms';

import { Observable } from 'rxjs';
import { map, tap } from 'rxjs/operators';

import { QuestionEditor } from '../../models/question-editor.model';
import { SurveyEditorService } from '../../services/survey-editor.service';

@Component({
  selector: 'empathy-list-questions-hidden',
  templateUrl: 'list-questions-hidden.component.html',
  styleUrls: ['./list-questions-hidden.component.scss']
})
export class ListQuestionsHiddenComponent implements OnInit {
  forceActiveHiddenQuestion = input<string>();

  filterComments = output<string>();
  forcedActivation = output<void>();

  questionsHidden$: Observable<QuestionEditor[]>;
  activeHiddenQuestionId$ = signal<string>('');
  count$ = signal(0);

  private surveyEditorService = inject(SurveyEditorService);

  constructor() {
    effect(
      () => {
        if (this.forceActiveHiddenQuestion()) {
          this.onActivate(this.forceActiveHiddenQuestion());
        }
      },
      { allowSignalWrites: true }
    );
  }

  ngOnInit(): void {
    this.questionsHidden$ = this.surveyEditorService.questionsHidden$.pipe(
      map((questionsHidden: FormArray) => questionsHidden.value as QuestionEditor[]),
      tap((questionsHidden: QuestionEditor[]) => this.activeHiddenQuestionId$.set(questionsHidden.find((q: QuestionEditor) => q.active === true)?.id)),
      tap((questionsHidden) => this.count$.set(questionsHidden.length))
    );
  }

  onActivate(questionId: string): void {
    this.activeHiddenQuestionId$.set(questionId);
    this.surveyEditorService.selectHiddenQuestion(questionId);
    this.filterComments.emit(questionId);

    if (this.forceActiveHiddenQuestion()) {
      this.forcedActivation.emit();
    }
  }
}
